import React from 'react';
import { MapWithScript, Map } from '../maps';
import CircularProgressBar from './CircularProgressBar';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { styled } from '@mui/material/styles';
import { COLORS, SPACING } from '../../styles/theme';
import { LocationItem, LocationCallLogMessage } from '../../services/api/types';

const StyledForm = styled('div')(() => ({
  margin: 'auto',
  padding: SPACING.FORM_PADDING,
  overflow: 'inherit',
}));

const StyledHeader = styled(CardHeader)(({ theme }) => ({
  borderBottomColor: theme.palette.divider,
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  padding: 8,
  color: COLORS.TEXT_PRIMARY,
}));

const StyledContent = styled(CardContent)(() => ({
  '& .MuiPaper-elevation1': {
    boxShadow: '0 0 0 0',
  },
  padding: '0px',
  paddingBottom: '0px !important',
}));

export interface LocationCardProps {
  title: string;
  locationLoaded: boolean;
  data: LocationItem | null;
  onPlaceChanged?: (
    place: LocationItem | null,
    logMessage: LocationCallLogMessage,
  ) => void;
  cardHeaderClass?: any;
  isCountryCodeRestrict: boolean;
}
export const LocationCard = ({
  title,
  data,
  locationLoaded,
  onPlaceChanged,
  cardHeaderClass,
  isCountryCodeRestrict,
}: LocationCardProps) => {
  return (
    <StyledForm>
      <Card>
        {cardHeaderClass ? (
          <CardHeader
            title={title}
            className={cardHeaderClass}
            disableTypography
          />
        ) : (
          <StyledHeader title={title} disableTypography />
        )}
        <StyledContent>
          {!locationLoaded ? (
            <div
              style={{
                width: '100%',
                height: '300px',
                textAlign: 'center',
              }}
            >
              <div style={{ marginTop: '50px' }}>
                <div className="MuiProgressOverlay">
                  <CircularProgressBar />
                </div>
              </div>
            </div>
          ) : (
            <MapWithScript
              map={
                <Map
                  onPlaceChanged={onPlaceChanged}
                  height="515px"
                  width="100%"
                  data={data}
                  isCountryCodeRestrict={isCountryCodeRestrict}
                />
              }
              loading={
                <div
                  style={{
                    width: '100%',
                    height: '300px',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ marginTop: '50px' }}>
                    <div className="MuiProgressOverlay">
                      <CircularProgressBar />
                    </div>
                  </div>
                </div>
              }
            />
          )}
        </StyledContent>
      </Card>
    </StyledForm>
  );
};
